// Category groups shown in the Navbar's "Search by category" submenu.
// Each entry maps a group label → list of BUSINESS_CATEGORIES that belong to it.
// Categories NOT listed here fall into the "All categories" bucket (rendered
// after the grouped sections). Keep this in sync with `BUSINESS_CATEGORIES`
// in /app/backend/server.py when new categories are added.

export const CATEGORY_GROUPS = [
  {
    label: "Trades & Home Services",
    testid: "trades-home-services",
    members: [
      "HVAC",
      "Plumbing",
      "Electrical",
      "Masonry",
      "Construction",
      "Roofing",
      "Landscaping",
      "Cleaning Services",
      "Automotive",
      "Painting",
      "Carpentry",
      "Handyman",
    ],
  },
];

const GROUPED_SET = new Set(
  CATEGORY_GROUPS.flatMap((g) => g.members)
);

/**
 * Split an ordered list of {name, count} into grouped sections + a
 * remainder ("All categories") preserving the input order within each bucket.
 */
export function groupCategories(activeCategories) {
  const byName = new Map(activeCategories.map((c) => [c.name, c]));
  const groups = CATEGORY_GROUPS.map((g) => ({
    label: g.label,
    testid: g.testid,
    items: g.members
      .map((name) => byName.get(name))
      .filter(Boolean),
  })).filter((g) => g.items.length > 0);

  const rest = activeCategories.filter((c) => !GROUPED_SET.has(c.name));
  return { groups, rest };
}
